const steps = [
  {
    number: '01',
    icon: 'ri-file-search-line',
    title: 'Project Review',
    description: 'We assess the scope, timeline, and specific cleaning requirements of your construction project before any work begins.',
  },
  {
    number: '02',
    icon: 'ri-calendar-check-line',
    title: 'Scheduled Service',
    description: 'We coordinate directly with your build schedule and deadlines to ensure cleaning happens at exactly the right phase.',
  },
  {
    number: '03',
    icon: 'ri-brush-line',
    title: 'Deep Cleaning Execution',
    description: 'Our crew removes all debris, construction dust, and residue — working systematically through every area of the site.',
  },
  {
    number: '04',
    icon: 'ri-check-double-line',
    title: 'Final Detail Finish',
    description: 'We complete a thorough detail pass ensuring every surface is clean, polished, and ready for final walkthrough or occupancy.',
  },
];

export default function Process() {
  return (
    <section id="process" className="bg-[#f5f4f0] py-24 px-6 md:px-16 lg:px-24">
      {/* Header */}
      <div className="text-center mb-16">
        <div className="inline-flex items-center gap-2 mb-4">
          <div className="w-8 h-px bg-[#C9A84C]"></div>
          <span className="font-inter text-[#C9A84C] text-xs tracking-widest uppercase">Our Process</span>
          <div className="w-8 h-px bg-[#C9A84C]"></div>
        </div>
        <h2 className="font-barlow-condensed font-900 text-[#1a1a1a] text-4xl md:text-5xl lg:text-6xl leading-none">
          FROM DUSTY SITE TO<br /><span className="text-[#C9A84C]">SPOTLESS FINISH</span>
        </h2>
      </div>

      {/* Steps */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {steps.map((step, idx) => (
          <div key={step.number} className="relative">
            {/* Connector line */}
            {idx < steps.length - 1 && (
              <div className="hidden lg:block absolute top-10 left-full w-full h-px bg-[#C9A84C]/20 z-0" style={{ width: 'calc(100% - 80px)', left: '80px' }}></div>
            )}

            <div className="bg-white rounded-sm p-8 relative z-10 h-full flex flex-col">
              {/* Number */}
              <div className="font-barlow-condensed font-900 text-[#C9A84C]/20 text-5xl leading-none mb-4">{step.number}</div>

              {/* Icon */}
              <div className="w-12 h-12 flex items-center justify-center bg-[#1a1a1a] rounded-sm mb-5">
                <i className={`${step.icon} text-[#C9A84C] text-xl`}></i>
              </div>

              {/* Content */}
              <h3 className="font-barlow font-800 text-[#1a1a1a] text-base mb-3 tracking-wide">{step.title}</h3>
              <p className="font-inter text-[#1a1a1a]/55 text-sm leading-relaxed flex-1">{step.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Bottom image strip */}
      <div className="mt-16 grid grid-cols-3 gap-4 rounded-sm overflow-hidden">
        <div className="h-48 overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/9ce1576c39d6adb2df945084175696d9.jpg"
            alt="Construction site before cleaning Las Vegas"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="h-48 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=professional%20cleaning%20crew%20working%20on%20construction%20site%2C%20workers%20in%20PPE%20safety%20gear%2C%20industrial%20cleaning%20equipment%2C%20action%20shot%2C%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%2C%20high%20contrast%20professional%20photography&width=600&height=300&seq=proc002&orientation=landscape"
            alt="Quiroz cleaning crew in action"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="h-48 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=spotless%20clean%20commercial%20interior%20after%20post-construction%20cleaning%2C%20polished%20floors%2C%20gleaming%20surfaces%2C%20bright%20modern%20space%2C%20move-in%20ready%20commercial%20building%2C%20clean%20minimal%20atmosphere%2C%20high%20end%20photography&width=600&height=300&seq=proc003&orientation=landscape"
            alt="Spotless result after construction cleaning Las Vegas"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}
